<template>
<div class="no-results">
    <div class="flex-row">
        <NuxtImg alt="Sad blue guy" src="/images/blue-lose-404.png" />
        <div v-if="text" class="flex-column">
            <p class="title-4">{{ $t(`${text}[0]`) }}</p>
            <p class="paragraph">{{ $t(`${text}[1]`) }}</p>
            <p class="paragraph">{{ $t(`${text}[2]`) }}</p>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        text: String
    }
})

</script>

<style lang="scss">
@use "$styles/kit.scss" as *;

.no-results {
        .flex-row {
            align-items: center;
            justify-content: center;
            min-height: 529px;
            padding: 32px;

            @include mq-xsmall {
                min-height: 0px;
            }
        }

        img {
            height: 232px;
            width: 180px;
            margin-right: 40px;
        }

        @include mq-xsmall {
            img {
                height: auto;
                max-height: 200px;
                width: 40vw;
                margin-right: 20px;
            }

            .title-4{
                font-size: 26px;
                line-height: 26px;
            }
        }
    }
</style>
